<template>
    <div>
        <label>Asignar a</label>
        <div class="my-2" :class="errorsMat_type.error ? 'has-error' : ''">
            <select id="materializable_type" name="materializable_type" v-model="materializable_type" data-placeholder="Selecciona una opción" data-minimum-results-for-search="Infinity" class="input border select2 w-full" :class="errorsMat_type.error ? 'border-theme-6' : ''" @change="obtenerMaterializables()">
                <option value=""></option>
                <option value="asociacion" v-if="userType === 'asociacion'">Asociación</option>
                <option value="agencia" v-if="userType !== 'asociacion'">Agencia (imagen de tienda)</option>
                <option value="producto">Producto</option>
                <option value="promocion">Promoción</option>
                <option value="formacion">Formación</option>
                <option value="proceso">Proceso</option>
            </select>
            <div v-if="errorsMat_type.error" class="text-theme-6 mb-2">{{errorsMat_type.message}}</div>
        </div>

        <div v-show="materializable_type !== ''">
            <label id="materializable_label">{{materializable_label}}</label>
            <div class="my-2" :class="errorsMat_id.error ? 'has-error' : ''">
                <select id="materializable_id" name="materializable_id" v-model="materializable_id" data-placeholder="Selecciona una opción" class="input border select2 w-full" :class="errorsMat_id.error ? 'border-theme-6' : ''">
                    <option value=""></option>
                </select>
                <div v-if="errorsMat_id.error" class="text-theme-6 mb-2">{{errorsMat_id.message}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            oldType: {
                type: String,
                default: ''
            },
            oldId: {
                type: String,
                default: ''
            },
            userType: {
                type: String,
                default: ''
            },
            errorsMat_type: Object,
            errorsMat_id: Object
        },
        data() {
            return {
                oldData: false,
                materializables: null,
                materializable_type: '',
                materializable_id: '',
                materializable_label: ''
            }
        },
        methods: {
            obtenerMaterializables() {

                switch (this.materializable_type) {
                    case 'asociacion':
                        this.materializable_label = 'Selecciona una Asociación';
                        break;
                    case 'agencia':
                        this.materializable_label = 'Selecciona una agencia';
                        break;
                    case 'producto':
                        this.materializable_label = 'Selecciona un producto';
                        break;
                    case 'formacion':
                        this.materializable_label = 'Selecciona una formación';
                        break;
                    case 'promocion':
                        this.materializable_label = 'Selecciona una promoción';
                        break;
                    case 'proceso':
                        this.materializable_label = 'Selecciona un proceso';
                        break;
                };

                 this.$req.webservices.getMaterializables(this.materializable_type).then(async res => {
                     this.materializables = res.data;

                 }).catch(err => {
                     console.log('error:' + err)
                 })
            },
            setOldData(){
                this.materializable_id = this.oldId;
                $('#materializable_id').val(this.materializable_id);
                $('#materializable_id').trigger('change');
                this.oldData = false;
            }
        },
        mounted: function () {
            let self = this; // ámbito de vue
            // inicializas select2
            $('#materializable_type')
            .select2()
            // nos hookeamos en el evento tal y como puedes leer en su documentación
            .on('select2:select', function () {
                var value = $("#materializable_type").select2('data');
                // nos devuelve un array ahora simplemente asignamos el valor a tu variable selected de VUE
                self.materializable_type = value[0].id;
                self.obtenerMaterializables();
            });

            $('#materializable_id')
            .select2({
                placeholder: 'Selecciona una opción',
                data: self.materializables, // cargas los datos en vez de usar el loop
            })
            // nos hookeamos en el evento tal y como puedes leer en su documentación
            .on('select2:select', function () {
                var value = $("#materializable_id").select2('data');
                // nos devuelve un array
                // ahora simplemente asignamos el valor a tu variable selected de VUE
                self.materializable_id = value[0].id
            })

        //PRESELECCIONAR EN CASO DE ERROR DE VALIDACION VALORES OLD
            if(self.oldType != ''){
                this.oldData = true;
                $('#materializable_type').val(self.oldType);
                $('#materializable_type').trigger('change');
                self.materializable_type = self.oldType;
                this.obtenerMaterializables();
            }
        },
        watch: {
            materializables: function (options) {
                // update options
                $("#materializable_id").empty().select2({ data: options })
                if(this.oldData){
                    this.setOldData();
                }
            },
        },
    }
</script>
